import React from 'react';
import { useTranslation } from 'react-i18next';

import { DataTableCellProps, TableCell } from 'components/dataTable';
import { MenuItem } from 'components/dataTable/cells';
import { ActionMenu } from 'components/dataTable/cells/actionMenu';

import { COLUMN_IDS, LABELS } from '../../apiKeys.keys';

export const ActionsTableCell = ({ row, passedProps }: DataTableCellProps) => {
  const { t } = useTranslation();

  const handleEdit = () => {
    passedProps?.onEdit(row[COLUMN_IDS.ID]);
  };

  const handleDelete = () => {
    passedProps?.onDelete(row[COLUMN_IDS.ID]);
  };

  if (!passedProps?.canManageActions) {
    return <TableCell />;
  }

  return (
    <TableCell>
      <ActionMenu title={t(LABELS.ACTIONS.TITLE)}>
        <MenuItem onClick={handleEdit}>{t(LABELS.ACTIONS.EDIT)}</MenuItem>
        <MenuItem onClick={handleDelete}>{t(LABELS.ACTIONS.DELETE)}</MenuItem>
      </ActionMenu>
    </TableCell>
  );
};
